export function Copy<T>(source: T): T {

    return structuredClone(source);
}
